import { render, staticRenderFns } from "./ot-workflow-confirm-dialog.vue?vue&type=template&id=36322b24&scoped=true&"
import script from "./ot-workflow-confirm-dialog.vue?vue&type=script&lang=ts&"
export * from "./ot-workflow-confirm-dialog.vue?vue&type=script&lang=ts&"
import style0 from "./ot-workflow-confirm-dialog.vue?vue&type=style&index=0&id=36322b24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36322b24",
  null
  
)

export default component.exports